import React, { useMemo } from "react";
import styled, { css } from 'styled-components/macro';
import Grafica from "../../../components/Grafica/Grafica";
import { useLanguage, useTranslate } from "../../../contexts/languageContext";
import { useNomenclator } from "../../../contexts/nomenclatorContext";
import useMediaQuery, { useIsDesktop } from "../../../hooks/useMediaQuery";
import { useEchartsModal } from "../Hemiciclo/EchartsModal";
import { getOption } from "./repartoVotosOptions";


const RepartoVotos = ({camaraSeleccionada}) => {
    const t = useTranslate();
    const lang = useLanguage();
    const nomenclator = useNomenclator();
    const isSmall = useMediaQuery("screen and (max-width: 480px)");
    const isDesktop = useIsDesktop();
    const { events } = useEchartsModal();
    const option = useMemo(
      () => getOption(camaraSeleccionada, nomenclator, isSmall, isDesktop, t, lang),
      [camaraSeleccionada, nomenclator, isSmall, isDesktop, t, lang]
    )

    return (
      <div css={`
      width:100%};
    `}>
        <Title>{t('repartoVotos')}</Title>
        <Grafica
          option={option}
          animationDelay={200}
          events={events}
          css={`
            width: "100%"};
            height: 125px;
          `}
        />
      </div>
    );
}

const Title = styled.h2`
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  text-transform: uppercase;
  color: #1C4183;
  text-align: left;
  margin-left: 5%
`;

export default RepartoVotos;